<script>
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import { Col, Row } from "sveltestrap";
	import NewCaseFilterForm from "./New/NewCaseFilterForm.svelte";
	import NewCaseTable from "./New/NewCaseTable.svelte";
	import { navigate } from "svelte-routing";
	import client from "src/services/client";
	import {
		arrayToQueryParams,
		extractErrorMessage,
		queryArrStrToNum,
	} from "src/utils/misc";
	import {
		initPage,
		loading,
		sizeSelect,
		totalRecords,
		totalPages,
		damageReviewedData,
	} from "src/store/store";
	import queryString from "query-string";
	import { onMount } from "svelte";
	import UnderInvestigationFilterForm from "./UnderInvestigation/UnderInvestigationFilterForm.svelte";
	import ToQuoteFilterForm from "./ToQuote/ToQuoteFilterForm.svelte";
	import ToBillFilterForm from "./ToBill/ToBillFilterForm.svelte";
	import RejectedFilterForm from "./Rejected/RejectedFilterForm.svelte";
	import UnderInvestigationTable from "./UnderInvestigation/UnderInvestigationTable.svelte";
	import ToQuoteTable from "./ToQuote/ToQuoteTable.svelte";
	import ToBillTable from "./ToBill/ToBillTable.svelte";
	import RejectedTable from "./Rejected/RejectedTable.svelte";

	let items = [
		{
			label: "New",
			value: 0,
		},
		{
			label: "Investigating",
			value: 1,
		},
		{
			label: "Quoting",
			value: 2,
		},
		{
			label: "Billing",
			value: 3,
		},
		{
			label: "Rejected",
			value: 4,
		},
	];

	const filterForms = {
		0: NewCaseFilterForm,
		1: UnderInvestigationFilterForm,
		2: ToQuoteFilterForm,
		3: ToBillFilterForm,
		4: RejectedFilterForm,
	};

	const tableComponents = {
		0: NewCaseTable,
		1: UnderInvestigationTable,
		2: ToQuoteTable,
		3: ToBillTable,
		4: RejectedTable,
	};

	let err;
	let query = queryString.parse(window.location.search);
	let reportData;
	let caseData;
	let reportParams;
	let caseParams;
	let fetchParams;

	$: activeTab = query.tab ? parseInt(query.tab) : 0;

	async function handleVehicleSearch(e) {
		if (e !== "") {
			try {
				if (!e || e.trim() === "") {
					err = "Please enter a vehicle no.";
					throw new Error(err);
				}
				if (e.length <= 2 || e.length >= 20) {
					err = "Vehicle no must be between 2 and 20 characters.";
					throw new Error(err);
				}
				if (!/^[a-zA-Z0-9]+$/.test(e)) {
					err = "Vehicle no must be alphanumeric.";
					throw new Error(err);
				}
				let carRes = await client(`/v1/plateNumbers/${e}?limit=100`, {
					method: "GET",
					version: "Vehicle",
				});
				let carOptions = carRes.data.map((car) => {
					return {
						value: car.vehicleId,
						label: car.plateNo,
					};
				});
				return carOptions;
			} catch (error) {
				console.log(error);
				extractErrorMessage(error);
				return [];
			}
		}
	}

	async function changeFetchParams(params) {
		if (params === "") {
			fetchParams = {
				pageSize: 20,
				pageNumber: 1,
			};
			initPage.set(1);
			fetchData(fetchParams);
			return;
		} else {
			let newParams = { ...fetchParams, ...params };
			for (let key in newParams) {
				if (
					(Array.isArray(newParams[key]) &&
						newParams[key].length === 0) ||
					newParams[key] === ""
				) {
					delete newParams[key];
				}
			}

			fetchParams = newParams;
			fetchData(fetchParams);
		}
	}

	async function fetchData(params) {
		// Fetch data based on the active tab
		// 0 = New, 1 = Under Investigation, 4 = Rejected (Reports)
		// 2 = To Quote, 3 = To Bill (Cases)

		try {
			if (!params) {
				params = queryString.parse(window.location.search);
			}
			params.pageSize = $sizeSelect;
			loading.set(true);

			let endpoint = "";
			let queryNav = queryString.stringify(arrayToQueryParams(params));
			if ([0, 1, 4].includes(activeTab)) {
				endpoint = `/v1/caseManagement/reports?status=${activeTab}`;
			} else if ([2, 3].includes(activeTab)) {
				endpoint = `/v1/caseManagement/cases?status=${activeTab}`;
			}

			if (queryNav) {
				endpoint += `&${queryNav}`;
			}

			const res = await client(endpoint, {
				method: "GET",
				version: "Tasking",
			});

			navigate(`/issues/case-management?` + queryNav);

			if (res.status === 200) {
				if ([0, 1, 4].includes(activeTab)) {
					reportData = res.data.data;
					fetchParams = params;
					reportParams = params;
				} else if ([2, 3].includes(activeTab)) {
					caseData = res.data.data;
					caseParams = params;
				}

				totalRecords.set(res.data.totalCount);
				totalPages.set(res.data.totalPage);
				initPage.set(res.data.pageNumber);
			}
			loading.set(false);
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
			loading.set(false);
		}
	}

	function changeTab(tab) {
		activeTab = tab;
		navigate(`/issues/case-management?tab=${activeTab}`);
		fetchData();
	}

	onMount(() => {
		// Fetch data when the component mounts
		fetchData();
		localStorage.removeItem("damageReviewedData");
		damageReviewedData.set([]);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row class="d-flex align-items-center">
				<Col>
					<PageHeader title="Case Management" />
				</Col>
				<Col class="d-flex flex-row-reverse">
					<div>
						<CustomButton
							buttonText="Create new case"
							onClick={() =>
								navigate("/issues/case-management/create")}
						/>
					</div>
				</Col>
			</Row>
			<Row>
				<Col>
					<Tabs {items} {activeTab} fetch={changeTab} />
				</Col>
			</Row>
			<Row>
				<svelte:component
					this={filterForms[activeTab]}
					{handleVehicleSearch}
					changeSearchParams={changeFetchParams}
					params={fetchParams}
				/>
			</Row>
		</div>
	</Col>
	<Col>
		<svelte:component
			this={tableComponents[activeTab]}
			{caseData}
			{reportData}
			{changeFetchParams}
		/>
	</Col>
</Row>
